
import { useState } from 'react';
import { Link } from 'react-router-dom';

interface Material {
  id: number;
  title: string;
  image: string;
  link: string;
  description: string;
}

const materials: Material[] = [
  {
    id: 1,
    title: "Lacados",
    image: "/images/lacados/lacado_home.webp",
    link: "/lacados",
    description: "Fabricado sobre tablero MDF Hidrófugo macizo. Diseñado para aplicación en interior y aguantar humedades ambientales altas propias de un baño."
  },
  {
    id: 2,
    title: "Maderas naturales",
    image: "images/proyectos/p37.jpeg",
    link: "/maderas",
    description: "Roble, Roble vintage, Nogal, Mongoy, Etimoe, Ébano y Zebrano"
  },
  {
    id: 3,
    title: "Piedra natural",
    image: "images/piedras_naturales/piedrasnaturales_home.webp",
    link: "/piedra-natural",
    description: "Piedra 100% natural. Destaca por su gran resistencia, belleza y perdurabilidad en el tiempo. Nuestra gama de acabados plasmas la personalidad, el atractivo y el encanto de la piedra natural."
  },
  {
    id: 4,
    title: "Piedra compacta",
    image: "images/piedras_compactas/piedracompacta_home.webp",
    link: "/piedra-compacta",
    description: "La piedra compacta natural es un material que combina a la perfección tecnologia y naturalidad. Compuesto por un 95% en piedra natural y un 5% en resinas minerales."
  },
  {
    id: 5,
    title: "Porcelánico",
    image: "images/porcelanicos/porcelanico_hero.png",
    link: "/porcelanicos",
    description: "Entre las propiedades más destacadas de este material podemos encontrar su gran resistencia a multitud de circunstancias debido a su gran dureza superficial, ofreciendo grandes resultados contra rayados, abrasión y altas cargas de peso."
  },
  {
    id: 6,
    title: "Resina mineral",
    image: "images/resinas/resina_hero.jpg",
    link: "/resinas-minerales",
    description: "Material fabricado íntegramente al 100% con resinas minerales. Destacamos su facilidad de limpieza y su gran perdurabilidad en el tiempo."
  }
];

export default function MaterialsCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % materials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + materials.length) % materials.length);
  };

  const visibleMaterials = () => {
    const result = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentIndex + i) % materials.length;
      result.push(materials[index]);
    }
    return result;
  };

  return (
    <section className="materials-carousel py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light mb-6">Materiales</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Descubre nuestra selección de materiales premium, 
            cada uno cuidadosamente elegido por su calidad, durabilidad y belleza excepcional.
          </p>
        </div>
        
        <div className="carousel-container relative">
          <div className="carousel-wrapper overflow-hidden">
            <div className="carousel-slides flex transition-transform duration-500 ease-in-out">
              {visibleMaterials().map((material) => (
                <div key={material.id} className="carousel-slide flex-none w-full md:w-1/3 px-4">
                  <Link to={material.link} className="material-card block group">
                    <div className="material-image-wrapper relative overflow-hidden mb-6">
                      <img 
                        src={material.image}
                        alt={`Muebles de baño ${material.title} - Materiales premium Navamuel`}
                        className="material-image w-full h-96 object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-[#191a19]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    </div>
                    <h3 className="material-title text-center text-2xl md:text-3xl font-light mb-3">
                      <span>{material.title}<em className="font-light">{material.subtitle}</em></span>
                    </h3>
                    <p className="text-center text-sm text-gray-600">
                      {material.description}
                    </p>
                  </Link>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="carousel-button carousel-button-prev absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/80 hover:bg-white border border-gray-300 flex items-center justify-center transition-all cursor-pointer hidden md:flex"
          >
            <i className="ri-arrow-left-line text-xl"></i>
          </button>
          
          <button
            onClick={nextSlide}
            className="carousel-button carousel-button-next absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/80 hover:bg-white border border-gray-300 flex items-center justify-center transition-all cursor-pointer hidden md:flex"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>

          {/* Mobile Navigation Dots */}
          <div className="flex justify-center mt-8 space-x-2 md:hidden">
            {materials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-colors cursor-pointer ${
                  index === currentIndex ? 'bg-[#191a19]' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12">
          <Link to="/materiales" 
            className="inline-block bg-[#191a19] text-white px-8 py-4 hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            Ver todos los materiales
          </Link>
        </div>
      </div>
    </section>
  );
}
